import { useRef } from 'react';
import MonacoEditor, {EditorDidMount} from '@monaco-editor/react';
import prettier from 'prettier';
import parser from 'prettier/parser-babel';
import './codeEditor.css';

interface codeEditorProps {
  initialValue: string;
  onChange(value: string): void;
}

const CodeEditor: React.FC<codeEditorProps> = ({initialValue, onChange}) => {
  const editorRef = useRef<any>();

  const onEditorDidMount: EditorDidMount = (getValue, monacoEditor) => {
    editorRef.current = monacoEditor;
    monacoEditor.onDidChangeModelContent(()=>{
      onChange(getValue());
    });
    monacoEditor.getModel()?.updateOptions({tabSize: 2});
  }

  const onClickFormat = () => {
    // get current value from editor
    const unformatted = editorRef.current.getModel().getValue();
    // format that value
    const formatted = prettier.format(unformatted, {
      parser: 'babel',
      plugins: [parser],
      useTabs: false,
      semi: true,
      singleQuote: true
    }).replace(/\n$/, '');
    // set the formatted value back in the editor
    editorRef.current.setValue(formatted);

  }
  
  return (
    <div className='editor-wrapper'>
      <button className='button button-format is-primary is-small' onClick={onClickFormat}>Format</button> 
      <MonacoEditor
        editorDidMount={onEditorDidMount} 
        value={initialValue}
        height='100%' 
        language='javascript' 
        theme='dark'
        options={{
          wordWrap: 'on',
          minimap: {enabled: false},
          showUnused: false,
          folding: false,
          lineNumbersMinChars: 3,
          fontSize: 16,
          scrollBeyondLastLine: false,
          automaticLayout: true
        }}
      />
    </div>
  );
}

export default CodeEditor;